import { getAlmConnectionId, getAlmInfo } from "@/backend/read/BackendReader";
import type { BoardType } from "@/model/baseTypes";
import { currentRoute } from "@/router/navigation";
import { useSessionStore } from "@/store/session";
import { useUserStore } from "@/store/user";
import { adminUrl } from "@/utils/env/Environment";

export function cockpitSessionUrl(
  options: { boardType?: BoardType; noNav?: boolean; boardId?: string } = {},
) {
  const sessionId = useSessionStore().current.id;
  if (!sessionId) {
    return cockpitPath("safepiplannings");
  }
  const path = boardTypeSetupPath[options.boardType!] ?? "generalInformation";
  const navQuery =
    (options.boardId ? "&boardId=" + options.boardId : "") + (options.noNav ? "&noNav" : "");
  return cockpitPath(`edit-session?id=${sessionId}&path=${path}${navQuery}`, {
    noFrom: options.noNav,
  });
}
export function cockpitProfileUrl(path?: string) {
  const sessionId = useSessionStore().current.id;
  path = encodeURIComponent(path || "");
  return sessionId && cockpitPath(path ? `profile?mapping=${sessionId}&path=${path}` : "profile");
}

export function cockpitConnectionUrl(teamId?: string) {
  const almConnectionId = getAlmConnectionId() || "";
  const almPath = getAlmInfo().cockpitPath;
  const teamPath = teamId && almConnectionId ? `/teams/${teamId}` : "";
  return cockpitPath(`alm-connections/${almPath}/${almConnectionId}${teamPath}`);
}

export function cockpitBillingUrl() {
  return cockpitPath(useUserStore().isTraining ? "trainingBilling" : "billing");
}

export function cockpitRegisterUrl() {
  return cockpitPath("register", { noFrom: true });
}

function cockpitPath(url: string, { noFrom = false } = {}) {
  const add = url.includes("?") ? "&" : "?";
  const from = noFrom ? "" : `${add}from=${encodeURIComponent(currentRoute().fullPath)}`;
  return `${adminUrl}/${url}${from}`;
}

const boardTypeSetupPath: Partial<Record<BoardType, string>> = {
  backlog: "programBacklogBoard",
  program: "programBoard",
  solution: "solutionPlanningBoard",
  solution_backlog: "solutionBacklogBoard",
  risk: "riskBoard",
  team: "teamBoards",
  flex: "flexBoards",
};
